module.exports = __webpack_public_path__ + "img/loading.97a90f46.gif";